// 慧课堂会议页,因原远程认证会刷新页面,只能抽离.

import React from "react";
import { component_tool, utils_tool } from "@/tool";
import { encry } from "../../../online/live/hostHkt/urlEncryption";
import { hkt_env_host } from '@/constants/constants_env'
import './index.less'

const { WizComponent } = component_tool;
let { Session } = utils_tool
const { userEmail = '', lectureName = '', userPassword = '', meetingNo = '', avatar } = Session.get('hktClassroomInfo') || {};

export default class Conference extends WizComponent {

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    // 就是不重新渲染...
    shouldComponentUpdate(nextProps, nextState) {
        return false
    }

    // 转换url
    renderUrl = () => {
        let en = encry(userEmail, lectureName, atob(userPassword), 1, "", "", getOssFilePath(avatar))
        let url = `${hkt_env_host}/${meetingNo}?${en}`
        return url
    }


    render() {
        return <iframe allowfullscreen="true" allow="microphone;camera;" className="meeting-iframe" frameborder="0" src={this.renderUrl()}></iframe>
    }

}